// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
}

.not-found-content {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.not-found-content h1 {
  font-size: 8rem;
  color: #dc3545;
  margin: 0;
  line-height: 1;
  font-weight: 700;
}

.not-found-content h2 {
  font-size: 2rem;
  color: #343a40;
  margin: 1rem 0;
  font-weight: 600;
}

.not-found-content p {
  color: #6c757d;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.not-found-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.home-link, .back-link {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 1rem;
}

.home-link {
  background-color: #007bff;
  color: white;
}

.home-link:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

.back-link {
  background-color: #6c757d;
  color: white;
}

.back-link:hover {
  background-color: #5a6268;
  transform: translateY(-2px);
}

@media (max-width: 576px) {
  .not-found-content {
    padding: 2rem;
  }

  .not-found-content h1 {
    font-size: 6rem;
  }

  .not-found-content h2 {
    font-size: 1.5rem;
  }

  .not-found-actions {
    flex-direction: column;
  }

  .home-link, .back-link {
    width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/NotFound.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".not-found-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f8f9fa;\n  padding: 20px;\n}\n\n.not-found-content {\n  text-align: center;\n  padding: 3rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 500px;\n  width: 100%;\n}\n\n.not-found-content h1 {\n  font-size: 8rem;\n  color: #dc3545;\n  margin: 0;\n  line-height: 1;\n  font-weight: 700;\n}\n\n.not-found-content h2 {\n  font-size: 2rem;\n  color: #343a40;\n  margin: 1rem 0;\n  font-weight: 600;\n}\n\n.not-found-content p {\n  color: #6c757d;\n  margin-bottom: 2rem;\n  font-size: 1.1rem;\n}\n\n.not-found-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.home-link, .back-link {\n  display: inline-block;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: none;\n  font-size: 1rem;\n}\n\n.home-link {\n  background-color: #007bff;\n  color: white;\n}\n\n.home-link:hover {\n  background-color: #0056b3;\n  transform: translateY(-2px);\n}\n\n.back-link {\n  background-color: #6c757d;\n  color: white;\n}\n\n.back-link:hover {\n  background-color: #5a6268;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 576px) {\n  .not-found-content {\n    padding: 2rem;\n  }\n\n  .not-found-content h1 {\n    font-size: 6rem;\n  }\n\n  .not-found-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .not-found-actions {\n    flex-direction: column;\n  }\n\n  .home-link, .back-link {\n    width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
